import Icons from "../Components/Icons/icons";

export const STORAGE_WORK_PLATFORM_ID = "workplatformid";
export const STORAGE_WORK_PLATFORM_NAME = "workplatformname";
export const CONNECTED_STORAGE_WORK_PLATFORM_ID = "connectedworkplatformid";
export const CONNECTED_USER_ID = "connecteduserid";
export const CONNECTED_ACCOUNT_ID = "connectedaccountid";
export const STORAGE_CONNECTION_STATE = "connectionstate";
export const STORAGE_AUTH_DATA = "auth";
export const STORAGE_CREATOR_INVITE_ID = "creator_invite_id";
export const STORAGE_CREATOR_ENVIRONMENT = "environment";
export const STORAGE_AUTH_SDK_TOKEN = "sdk_token";
export const STORAGE_AUTH_USER_ID = "user_id";
export const STORAGE_AUTH_TENANT_APP_NAME = "tenant_app_name";
export const STORAGE_AUTH_CREATOR_USER_NAME = "creator_name";
export const STAGING_ENVIRONMENT = "staging";
export const PRODUCTION_ENVIRONMENT = "production";

export const URL_QUERY_PARAMS_INVITE_CODE = "creator_invite_id";
export const URL_QUERY_PARAMS_ENVIRONMENT = "environment";

export const INSTAGRAM_WORK_PLATFORM_NAME = "instagram";

export const INSTAGRAM_WORK_PLATFORM_ID = "9bb8913b-ddd9-430b-a66a-d74d846e6c66";

export const TIKTOK_WORK_PLATFORM_ID = "de55aeec-0dc8-4119-bf90-16b3d1f0c987";

export const YOUTUBE_WORK_PLATFORM_ID = "14d9ddf5-51c6-415e-bde6-f8ed36ad7054";

export const FACEBOOK_WORK_PLATFORM_ID = "ad2fec62-2987-40a0-89fb-23485972598c";
export const TWITTER_WORK_PLATFORM_ID = "7645460a-96e0-4192-a3ce-a1fc30641f72";
export const TWITCH_WORK_PLATFORM_ID = "e4de6c01-5b78-4fc0-a651-24f44134457b";

export const CONNECTION_SUCCESS = "success";
export const CONNECTION_ABANDONED = "abandoned";
export const CONNECTION_ERROR = "error";

export const LANDING_PAGE_CONTENT = {
  invite_header:"Hey userName! 👋",
  invite_message: "invites you to securely link your social media accounts, where you share content and engage with your followers.",
  footer_link_text: "Learn more about data sharing via Phyllo",
  footer_link_url: "",
}

export const GENERIC_SCREEN_CONTENT = {
  header: "As you proceed, remember to",
  permissions: [{
    icon: <Icons.permissions_loading />,
    mobile_icon: <Icons.permissions_loading_mobile/> ,
    title: "Allow required permissions",
    message: "We'll need permission to access your data, but fear not, we promise not to post, modify, or delete anything!"
  },
  {
    icon: <Icons.content_loading />,
    mobile_icon: <Icons.content_loading_mobile />,
    title: "Select a relevant account",
    message: "Make sure to select the account where you create your awesome content."
  }]
}

export const INSTA_EDU_CONTENT = {
  header: "Connecting Instagram can be tricky",
  message: "Watch the video below for step-by-step instructions to successfully connect your Instagram account.",
  videoUrl: "https://cdn.getphyllo.com/files/InstaConnectionGuide.mp4",
  attentionBoxContent: {
    title: "Have more questions about the connection?",
    icon: <Icons.attention_icon />,
    text_url: [{
      text: "Check the help guide here",
      url: "https://help.getphyllo.com/?lang=en"
    }]
  }
}

export const SUCCESS_PAGE_CONTENT = {
  header: "Yay! Account connected with",
  icon: <Icons.success_icon />,
  contactInfo: ["If you have any questions or concerns, please contact appName. ", "Or get in touch with us at <a href=mailto:support@getphyllo.com target=_black >support@getphyllo.com</a>."],
  instaAttentionMsg: {
    title: "Connect your Facebook separately",
    icon: <Icons.attention_icon />,
    text: "To connect your Facebook account, ensure it's done individually, even if you have connected Instagram."
  }
}

export const ABANDONED_PAGE_CONTENT = {
  header: "You did not connect your account",
  icon: <Icons.heart_break_icon />,
  contactInfo: ["If you have any questions or concerns, please contact appName. ", "Or get in touch with us at <a href=mailto:support@getphyllo.com target=_black >support@getphyllo.com</a>."],
  abandonedAttentionMsg: {
    title: "Concerned about the permissions?",
    icon: <Icons.attention_icon />,
    text: "Don’t worry, we won't post, modify, or delete anything. We need it to access your data.",
  }
}
export const INVITE_EXPIRED_PAGE_CONTENT = {
  header: "Uh-oh! The invite has expired",
  icon: <Icons.heart_break_icon />,
  message: "The invitation to connect your accounts has expired. Please get in touch with S.H.I.E.L.D for more details.",
}

export const ERROR_PAGE_CONTENT = {
  header: "What might be causing connection problems?",
  icon: <Icons.thinking_icon />,
  contactInfo: ["If you have any questions or concerns, please contact appName. ", "Or get in touch with us at <a href=mailto:support@getphyllo.com target=_black >support@getphyllo.com</a>."],
  instaErrorContent: [{
    title: "You don’t have an Instagram creator or business account",
    text_url: [{
      text: "Check Instagram account type",
      url: "https://help.getphyllo.com/check-type-of-instagram-account?lang=en"
    },
    {
      text: "Change Instagram account type",
      url: "https://help.getphyllo.com/change-type-of-instagram-account?lang=en"
    }
    ]
  }, {
    title: "You don't have a FB Page linked to their Instagram account.",
    text_url: [{
      text: "Check if Instagram account is linked to a Facebook Page",
      url: "https://help.getphyllo.com/check-if-instagram-account-is-linked-to-facebook-page?lang=en"
    },
    {
      text: "Link Instagram account to a Facebook Page?",
      url: "https://help.getphyllo.com/link-instagram-account-to-facebook-page?lang=en"
    }
    ]
  },
  {
    title: "You didn't provide the required permissions.",
    permission: {
      icon: <Icons.permissions_loading_small />,
      title: "Allow required permissions",
      message: "Don’t worry, we won't post, modify, or delete anything. We need it to access your data."
    }
  },
  {
    title: "You selected the wrong combination of Instagram account and FB page while logging in via FB.",
    videoUrl:{
      text: "See how to do it correctly",
      url: "https://cdn.getphyllo.com/files/InstaConnectionGuide.mp4"}
  }],
  otherPlatformErrorContent :[{
    title: "You didn't provide the required permissions.",
    permission: {
      icon: <Icons.permissions_loading_small />,
      title: "Allow required permissions",
      message: "Don’t worry, we won't post, modify, or delete anything. We need it to access your data."
    }
  },
  {
    title: "You didn't select the right account when connecting.",
     permission: {
      icon: <Icons.content_loading_small />,
      title: "Select a relevant account",
      message: "Make sure to select the account where you create your awesome content."
  }
  }]
}

export const CONNECTION_STEP_CONTENT = {
  header: "Secure connection through Phyllo",
  steps: [{
    title:"Upon selecting the platform, Phyllo SDK will guide you to securely link your creator accounts.",
    icon: <Icons.connection_step1/>
  },
  {
    title:"Login occurs on the selected platform. We'll need permission to access your data, but fear not, we promise not to post, modify, or delete anything!",
    icon: <div className="img-grey-bg" ><img src={require('../Pages/ConnectionSteps.jsx/connection_step2.gif')} alt="step2" /></div>
  },{
    title:"Voila! Account connected! Your data is shared safely, only with your permission.",
    icon: <Icons.connection_step3/>
  }]
}





